<template>
	<el-dialog
		title="修改密码"
		:visible="visible"
		width="500px"
		:close-on-click-modal="false"
        :before-close="handleClose"
		@open="initEditForm"
	>
		<el-form
			:model="editForm"
			:rules="rules"
			ref="editForm"
			style="width: 400px"
			label-width="100px"
		>
			<!-- <el-form-item prop="oldPassword" label="当前密码">
				<el-input
					type="password"
					v-model="editForm.oldPassword"
					placeholder="请输入当前密码"
					auto-complete="off"
				></el-input>
			</el-form-item> -->
            <el-form-item label="用户名">
                <span>{{ user.username }}</span>
            </el-form-item>
            <el-form-item label="姓名">
                <span>{{ user.name }}</span>
            </el-form-item>
			<el-form-item prop="newPassword" label="新密码">
				<el-input
					type="password"
					v-model="editForm.newPassword"
					placeholder="请输入新密码"
					auto-complete="off"
				></el-input>
			</el-form-item>
			<el-form-item prop="newPassword2" label="确认新密码">
				<el-input
					type="password"
					v-model="editForm.newPassword2"
					placeholder="请再次输入新密码"
					auto-complete="off"
				></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="saveing" @click="handleSave">保 存</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
        user: {
            type: Object,
            require: true
        }
	},
	data() {
		const validPassword = (rule, value, callback) => {
			if (value !== "" && this.editForm.newPassword2 !== "") {
				this.$refs.editForm.validateField("newPassword2");
			}
			callback();
		};
		const validPassword2 = (rule, value, callback) => {
			if (value !== "" && value !== this.editForm.newPassword) {
				callback(new Error("两次输入密码不一致！"));
			} else {
				callback();
			}
		};
		return {
            saveing: false,
			editForm: {
                id: "",
				newPassword: "",
				newPassword2: "",
			},
			rules: {
				newPassword: [
					{
						required: true,
						message: "请输入新密码",
						trigger: "blur",
					},
					{
						min: 6,
						max: 24,
						message: "密码长度控制在6到24个字符",
						trigger: "blur",
					},
					{
						validator: validPassword,
						trigger: "blur",
					},
				],
				newPassword2: [
					{
						required: true,
						message: "请再次输入新密码",
						trigger: "blur",
					},
					{
						validator: validPassword2,
						trigger: "blur",
					},
				],
			},
		};
	},
	methods: {
		initEditForm() {
            this.$refs.editForm?.resetFields();
            this.editForm.id = this.user.id;
        },
        handleSave() {
            this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.saveing = true;
                    this.$api.system.resetPassword(this.editForm).then(res => {
                        this.saveing = false;
                        if (res.code === 200) {
                            this.$message.success("修改成功！");
                            this.$emit("close", true);
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }
            });
        },
        handleClose() {
            this.$emit("close", false);
        }
	},
    mounted() {
        this.initEditForm()
    },
};
</script>

<style>
</style>
